import { noop } from "lib";

export const createStyleElement = elementId => {
  const styleId = `sheet-${elementId}`;
  if (!!document.querySelector(`style[id="${styleId}"]`)) return;
  // Create a new style element
  const style = document.createElement("style");

  style.setAttribute("id", styleId);

  document.head.appendChild(style);
};

export const applyParagraphStyling = noop;
